import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Track } from 'livekit-client';
import { MediaDeviceSelect, TrackToggle } from '@livekit/components-react';
import { Button } from '@spotted-zebra-uk/ui-components';
import Icon from 'components/atoms/Icon';
import styles from './AvatarControls.module.scss';

interface AvatarControlsProps {
  onEndCall: () => void;
  isDisconnecting: boolean;
}

export function AvatarControls({ onEndCall, isDisconnecting }: AvatarControlsProps) {
  const { t } = useTranslation();
  const [showDeviceSettings, setShowDeviceSettings] = useState(false);

  return (
    <div className={styles.avatarControls}>
      <div className={styles.controlsContainer}>
        <div className={styles.mainControls}>
          <TrackToggle
            source={Track.Source.Microphone}
            showIcon={true}
            className={styles.trackToggle}
          />

          <button
            onClick={() => setShowDeviceSettings(!showDeviceSettings)}
            className={styles.settingsButton}
            aria-label={t('aiInterview.deviceSettings')}
          >
            <Icon icon="settings" width={24} height={24} />
          </button>

          <Button
            onClick={onEndCall}
            disabled={isDisconnecting}
            className={styles.endCallButton}
          >
            {isDisconnecting ? t('aiInterview.leaving') : t('aiInterview.endCall')}
          </Button>
        </div>

        {showDeviceSettings && (
          <div className={styles.deviceSettings}>
            <div className={styles.deviceSelectGroup}>
              <label>
                {t('aiInterview.microphone')}
                <MediaDeviceSelect kind="audioinput" />
              </label>
            </div>

            <div className={styles.deviceSelectGroup}>
              <label>
                {t('aiInterview.speaker')}
                <MediaDeviceSelect kind="audiooutput" />
              </label>
            </div>

            <div className={styles.deviceSelectGroup}>
              <label>
                {t('aiInterview.camera')}
                <MediaDeviceSelect kind="videoinput" />
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
